import { HttpHeaders } from '@angular/common/http';

export class BaseService {

  GetDefaultHeaders() : Promise<HttpHeaders> {
      let contentHeaders = new HttpHeaders({
					'Accept': 'application/json',
					'Content-Type':  'application/json'
      });

      return Promise.resolve(contentHeaders);
  }
}